/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import AnswerDto from './AnswerDto';

/**
 * The QuestionDetailsDto model module.
 * @module model/QuestionDetailsDto
 * @version v0
 */
class QuestionDetailsDto {
    /**
     * Constructs a new <code>QuestionDetailsDto</code>.
     * @alias module:model/QuestionDetailsDto
     * @param content {String} 
     * @param difficulty {Number} 
     */
    constructor(content, difficulty) { 
        
        QuestionDetailsDto.initialize(this, content, difficulty);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, content, difficulty) { 
        obj['content'] = content;
        obj['difficulty'] = difficulty;
    }

    /**
     * Constructs a <code>QuestionDetailsDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/QuestionDetailsDto} obj Optional instance to populate.
     * @return {module:model/QuestionDetailsDto} The populated <code>QuestionDetailsDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new QuestionDetailsDto();

            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('content')) {
                obj['content'] = ApiClient.convertToType(data['content'], 'String');
            }
            if (data.hasOwnProperty('interpretation')) {
                obj['interpretation'] = ApiClient.convertToType(data['interpretation'], 'String');
            }
            if (data.hasOwnProperty('difficulty')) {
                obj['difficulty'] = ApiClient.convertToType(data['difficulty'], 'Number');
            }
            if (data.hasOwnProperty('created_at')) {
                obj['created_at'] = ApiClient.convertToType(data['created_at'], 'Date');
            }
            if (data.hasOwnProperty('updated_at')) {
                obj['updated_at'] = ApiClient.convertToType(data['updated_at'], 'Date');
            }
            if (data.hasOwnProperty('created_by')) {
                obj['created_by'] = ApiClient.convertToType(data['created_by'], 'String');
            }
            if (data.hasOwnProperty('updated_by')) {
                obj['updated_by'] = ApiClient.convertToType(data['updated_by'], 'String');
            }
            if (data.hasOwnProperty('answers')) {
                obj['answers'] = ApiClient.convertToType(data['answers'], [AnswerDto]);
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>QuestionDetailsDto</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>QuestionDetailsDto</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of QuestionDetailsDto.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['content'] && !(typeof data['content'] === 'string' || data['content'] instanceof String)) {
            throw new Error("Expected the field `content` to be a primitive type in the JSON string but got " + data['content']);
        }
        // ensure the json data is a string
        if (data['interpretation'] && !(typeof data['interpretation'] === 'string' || data['interpretation'] instanceof String)) {
            throw new Error("Expected the field `interpretation` to be a primitive type in the JSON string but got " + data['interpretation']);
        }
        // ensure the json data is a string
        if (data['created_by'] && !(typeof data['created_by'] === 'string' || data['created_by'] instanceof String)) {
            throw new Error("Expected the field `created_by` to be a primitive type in the JSON string but got " + data['created_by']);
        }
        // ensure the json data is a string
        if (data['updated_by'] && !(typeof data['updated_by'] === 'string' || data['updated_by'] instanceof String)) {
            throw new Error("Expected the field `updated_by` to be a primitive type in the JSON string but got " + data['updated_by']);
        }
        if (data['answers']) { // data not null
            // ensure the json data is an array
            if (!Array.isArray(data['answers'])) {
                throw new Error("Expected the field `answers` to be an array in the JSON data but got " + data['answers']);
            }
            // validate the optional field `answers` (array)
            for (const item of data['answers']) {
                AnswerDto.validateJSON(item);
            };
        }

        return true;
    }


}

QuestionDetailsDto.RequiredProperties = ["content", "difficulty"];

/**
 * @member {Number} id
 */
QuestionDetailsDto.prototype['id'] = undefined;

/**
 * @member {String} content
 */
QuestionDetailsDto.prototype['content'] = undefined;

/**
 * @member {String} interpretation
 */
QuestionDetailsDto.prototype['interpretation'] = undefined;

/**
 * @member {Number} difficulty
 */
QuestionDetailsDto.prototype['difficulty'] = undefined;

/**
 * @member {Date} created_at
 */
QuestionDetailsDto.prototype['created_at'] = undefined;

/**
 * @member {Date} updated_at
 */
QuestionDetailsDto.prototype['updated_at'] = undefined;

/**
 * @member {String} created_by
 */
QuestionDetailsDto.prototype['created_by'] = undefined;

/**
 * @member {String} updated_by
 */
QuestionDetailsDto.prototype['updated_by'] = undefined;

/**
 * @member {Array.<module:model/AnswerDto>} answers
 */
QuestionDetailsDto.prototype['answers'] = undefined;






export default QuestionDetailsDto;

